export default __webpack_public_path__ + "static/media/image-delete.5f7f92b7.svg";